import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap';
import moment from 'moment';
import { getInitials, handlePriorityStatus, handleTaskStatus } from '../../utility/CommonFunctions';
import { apiUrl } from '../../ApiHelper/ApiUrl';
import { callApi } from '../../ApiHelper/ApiHelper';
import { toast } from 'react-toastify';
import PlusIcon from '../../components/Icons/PlusIcon';

const TaskDetailModal = ({ isOpen, toggle, selectedTask, getTaskList, userDetails, activeTab, toggleAddEditSubTaskModal, refreshSubTask, setIsCreateSubTask }) => {
    if (!selectedTask) return null;

    const [taskDetail, setTaskDetail] = useState({});
    const [isLoadingDetail, setIsLoadingDetail] = useState(false);
    const [isLoadingComment, setIsLoadingComment] = useState(false);
    const [isLoadingCommentDelete, setIsLoadingCommentDelete] = useState(false);

    const getPriorityColor = (priority) => {
        switch (priority?.toLowerCase()) {
            case "low": return "#10B981";
            case "medium": return "#F59E0B";
            case "high": return "#EF4444";
            default: return "#9CA3AF";
        }
    };
    const [isLoadingStatus, setIsLoadingStatus] = useState(false);
    const [comment, setComment] = useState("");

    const renderAvatar = (user, bgColor = "#E28743", textColor = "#FFFFFF", size = "24px", fontSize = "10px") => {
        if (!user) return null;
        let initials = "";
        if (user?.name) {
            const nameParts = user.name.split(" ");
            initials = nameParts.length > 1
                ? nameParts[0].charAt(0) + nameParts[1].charAt(0)
                : nameParts[0].charAt(0);
        } else {
            initials = "U";
        }
        return (
            <div
                className="rounded-circle d-flex align-items-center justify-content-center shadow-sm flex-shrink-0"
                style={{
                    backgroundColor: bgColor,
                    color: textColor,
                    width: size,
                    height: size,
                    minWidth: size,
                    fontSize: fontSize,
                    fontWeight: "700",
                    letterSpacing: "0.5px"
                }}
                title={user?.name || "Unknown User"}
            >
                {initials.toUpperCase()}
            </div>
        );
    };

    const onChangeStatus = (taskId, status) => {
        let submitData = {
            taskId: taskId,
            status: status
        };
        let options = {
            method: "PUT",
            data: submitData,
        };
        const API = apiUrl.update_task;
        setIsLoadingStatus(true);
        callApi(API, options).then((response) => {
            setIsLoadingStatus(false);
            if (response?.status === true) {
                toast.success(response.message);
                GetTaskDetail();
                if (getTaskList) getTaskList();
            } else {
                toast.error(response.message);
            }
        });
    };

    useEffect(() => {
        if (isOpen == true) {
            GetTaskDetail();
        }
    }, [isOpen, refreshSubTask]);

    const GetTaskDetail = () => {
        let options = {
            method: "GET",
        };
        let API = apiUrl?.get_task_detail + `?taskId=${selectedTask?.id}`;
        setIsLoadingDetail(true);
        callApi(API, options).then((response) => {
            setIsLoadingDetail(false);
            if (response?.status === true) {
                setTaskDetail(response?.data);
            } else {
                toast.error(response?.message);
            }
        });
    };

    const handleAddComment = () => {
        const submitData = {
            taskId: taskDetail?.id,
            comment: comment
        };
        let options = {
            method: "POST",
            data: submitData
        };
        let API = apiUrl?.add_comment;
        setIsLoadingComment(true);
        callApi(API, options).then((response) => {
            setIsLoadingComment(false);
            if (response?.status === true) {
                setComment("");
                GetTaskDetail();
            } else {
                toast.error(response?.message);
            }
        });
    }

    const handleCommentDelete = (taskCommentId) => {
        let options = {
            method: "DELETE",
        };
        let API = apiUrl?.delete_comment + `?taskCommentId=${taskCommentId}`;
        setIsLoadingCommentDelete(true);
        callApi(API, options).then((response) => {
            setIsLoadingCommentDelete(false);
            if (response?.status === true) {
                toast.success(response?.message);
                GetTaskDetail();
            } else {
                toast.error(response?.message);
            }
        });
    }

    const handleCreateSubTask = (id) => {
        setIsCreateSubTask(true);
        toggleAddEditSubTaskModal();
    }

    const isOverdue = taskDetail?.status !== "Cancelled" && (
        (taskDetail?.status === "Done" && moment(taskDetail?.completedDate).isAfter(taskDetail?.dueDate, 'day')) ||
        (taskDetail?.status !== "Done" && moment(taskDetail?.dueDate).isBefore(moment(), 'day'))
    );



    return (
        <Modal isOpen={isOpen} toggle={toggle} scrollable centered size="xl" >
            <ModalHeader toggle={toggle} className="border-0 pb-2 pt-4 px-4 bg-white rounded-top-4" tag="div">
                <div className="d-flex align-items-center gap-3">
                    <span style={{ fontSize: "11px", fontWeight: "600", color: taskDetail?.parentTaskId != null ? '#257FFD' : '#878a99', letterSpacing: "0.3px" }} className="d-flex align-items-center gap-1 text-uppercase">
                        {taskDetail?.parentTaskId != null ? (
                            <>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16"><path fillRule="evenodd" d="M3.5 2a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 1 0V6a.5.5 0 0 1 .5-.5h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-9z" /><path fillRule="evenodd" d="M12.354 1.646a.5.5 0 0 1 0 .708L10.707 4l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2a.5.5 0 0 1 .708 0z" /></svg>
                                Sub Task -
                            </>
                        ) : (
                            <>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16"><path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v13A1.5 1.5 0 0 0 1.5 16h13a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 14.5 0h-13zM1 1.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-13z" /><path d="M5.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5zM5.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5zM5.5 12a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5z" /></svg>
                                Task -
                            </>
                        )}
                    </span>
                    <h5 className="fw-semibold text-dark mb-0 pe-3" style={{ letterSpacing: "-0.3px" }}>{taskDetail?.title}</h5>
                </div>
            </ModalHeader>
            <ModalBody className="px-4 pb-4 pt-2" style={{ backgroundColor: '#ffffff' }}>
                {isLoadingDetail ? (
                    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "300px" }}>
                        <Spinner color="primary" />
                    </div>
                ) : (
                    <div className="w-100">
                        <div className="d-flex flex-wrap align-items-center justify-content-between mb-4">
                            <div className='d-flex flex-wrap align-items-center gap-2'>
                                {handlePriorityStatus(taskDetail?.priority)}
                                {handleTaskStatus(taskDetail?.status)}
                                {isOverdue && (
                                    <span className="badge bg-danger-subtle text-danger fw-bold d-inline-flex align-items-center gap-1 px-2 py-1 border border-danger-subtle rounded-pill" style={{ fontSize: "12px" }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16"><path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" /></svg>
                                        OVERDUE
                                    </span>
                                )}
                                {taskDetail?.meetingId && (
                                    <div className="d-flex align-items-center text-muted bg-light px-3 py-1 rounded-pill border" style={{ fontSize: '13px', fontWeight: '500' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="me-2 text-primary" viewBox="0 0 16 16">
                                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                        </svg>
                                        <>Meeting <span className="text-dark fw-bold ms-1">: {taskDetail?.meeting?.title}</span></>

                                    </div>
                                )}
                            </div>
                            <div>
                                {(activeTab === "myTask" && !taskDetail?.parentTaskId) &&
                                    <button className="btn btn-outline-primary btn-sm rounded-pill" onClick={() => handleCreateSubTask(taskDetail?.id)}><PlusIcon size={16} className="me-1" />Create Sub Task</button>
                                }
                            </div>
                        </div>

                        <div className="p-2 mb-3 rounded-3 border-0" style={{ backgroundColor: '#f8fafc' }}>
                            <p className="mb-0 text-secondary" style={{ fontSize: '13px' }}>{taskDetail?.description || "No description provided."}</p>
                        </div>

                        <div className="row g-3 mb-4">
                            <div className="col-md-6">
                                <div className="p-2 border-0 rounded-3 bg-light h-100">
                                    <div className="text-muted text-uppercase mb-1 fw-bold" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>Task Type</div>
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="fw-bold text-dark text-capitalize" style={{ fontSize: "12px" }}>{taskDetail?.type || "--"}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="p-2 border-0 rounded-3 bg-light h-100">
                                    <div className="text-muted text-uppercase mb-1 fw-bold" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>Site</div>
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="fw-bold text-dark text-truncate" style={{ fontSize: "12px" }}>{taskDetail?.site?.name || "--"}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="p-2 border-0 rounded-3 bg-light h-100">
                                    <div className="text-muted text-uppercase mb-1 fw-bold" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>Accountable Person</div>
                                    <div className="d-flex align-items-center gap-2">
                                        {renderAvatar(taskDetail?.assignedUsers2?.[0], "#455bffff", "#FFFFFF", "24px", "10px")}
                                        <span className="fw-bold text-dark text-truncate" style={{ fontSize: "12px" }}>{taskDetail?.assignedUsers2?.[0]?.name || "Unknown"}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="p-2 border-0 rounded-3 bg-light h-100">
                                    <div className="text-muted text-uppercase mb-1 fw-bold" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>Created By</div>
                                    <div className="d-flex align-items-center gap-2">
                                        {renderAvatar(taskDetail?.taskCreator, "#e83e8c", "#FFFFFF", "24px", "10px")}
                                        <span className="fw-bold text-dark text-truncate" style={{ fontSize: "12px" }}>{taskDetail?.taskCreator?.name || "Unknown"}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="p-2 border-0 rounded-3 bg-light h-100">
                                    <div className="text-muted text-uppercase mb-1 fw-bold" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>Responsible Persons</div>
                                    <div className="d-flex align-items-center flex-wrap gap-2">
                                        {taskDetail?.assignedUsers?.length > 0 ? (
                                            taskDetail?.assignedUsers?.map((user, index) => (
                                                <div key={user?.id || index} className="d-flex align-items-center gap-1 bg-white rounded-pill pe-2 py-1 shadow-sm border border-light">
                                                    {renderAvatar(user, "#223c64ff", "#FFFFFF", "20px", "9px")}
                                                    <span className="fw-bold text-dark text-truncate" style={{ fontSize: "11px" }}>{user?.name}</span>
                                                </div>
                                            ))
                                        ) : (
                                            <span className="fw-bold text-dark text-truncate" style={{ fontSize: "12px" }}>Unassigned</span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="p-2 border-0 rounded-3 bg-light h-100">
                                    <div className="text-muted text-uppercase mb-1 fw-bold" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>Created</div>
                                    <div className="fw-bold text-secondary" style={{ fontSize: "12px" }}>
                                        {moment(taskDetail?.createdAt).format("DD MMM YYYY")}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="p-2 border-0 rounded-3 bg-light h-100">
                                    <div className="text-muted text-uppercase mb-1 fw-bold" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>Due Date</div>
                                    <div className={`fw-bold ${isOverdue ? 'text-danger' : 'text-dark'}`} style={{ fontSize: "12px" }}>
                                        {moment(taskDetail?.dueDate).format("DD MMM YYYY")}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="p-2 border-0 rounded-3 bg-light h-100">
                                    <div className="text-muted text-uppercase mb-1 fw-bold" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>Completed</div>
                                    <div className={`fw-bold ${isOverdue && taskDetail?.status === 'Done' ? 'text-danger' : 'text-secondary'}`} style={{ fontSize: "12px" }}>
                                        {taskDetail?.completedDate ? moment(taskDetail?.completedDate).format("DD MMM YYYY") : "N/A"}
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="mb-3">
                            <div className="text-muted text-uppercase mb-1 fw-bold" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>Update Status</div>
                            <select
                                className={`form-select px-2 py-1 rounded-5 shadow-sm border fw-bold ${taskDetail.status === 'To Do' ? 'bg-light text-secondary border-secondary-subtle' :
                                    taskDetail.status === 'In Progress' ? 'bg-primary-subtle text-primary border-primary-subtle' :
                                        taskDetail.status === 'Done' ? 'bg-success-subtle text-success border-success-subtle' :
                                            taskDetail.status === 'Cancelled' ? 'bg-danger-subtle text-danger border-danger-subtle' : ''
                                    }`}
                                value={taskDetail?.status || ''}
                                onChange={(e) => onChangeStatus(taskDetail.id, e.target.value)}
                                disabled={isLoadingStatus || taskDetail?.status === "Done" || taskDetail?.status === "Cancelled" || activeTab === "siteTask"}
                                style={{ width: "auto", minWidth: "120px", fontSize: "11px", cursor: (isLoadingStatus || taskDetail?.status === "Done" || taskDetail?.status === "Cancelled") ? "not-allowed" : "pointer" }}>
                                <option value="To Do" className="bg-light text-secondary fw-bold">To Do</option>
                                <option value="In Progress" className="bg-primary-subtle text-primary fw-bold">In Progress</option>
                                <option value="Done" className="bg-success-subtle text-success fw-bold">Done</option>
                                <option value="Cancelled" className="bg-danger-subtle text-danger fw-bold">Cancelled</option>
                            </select>
                        </div>

                        {taskDetail?.parentTaskId === null &&
                            <div className="pt-2">
                                <div className="text-muted text-uppercase mb-3 fw-bold" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Sub Tasks</div>
                                {taskDetail?.subTasks?.length === 0 ? (
                                    <p className="mb-3 text-muted" style={{ fontStyle: 'italic', fontSize: '13px' }}>No sub tasks yet.</p>
                                ) : (
                                    <div className="mb-3 d-flex flex-column gap-3 overflow-auto border rounded-3 p-2" style={{ maxHeight: '350px' }}>
                                        {taskDetail?.subTasks?.map((subTask) => (
                                            <div
                                                key={subTask.id}
                                                className="card shadow-sm rounded-4 overflow-hidden mb-3 flex-shrink-0"
                                                style={{ border: 'none', borderLeft: `4px solid ${getPriorityColor(subTask?.priority)}` }}
                                            >
                                                <div className="card-body p-3 d-flex flex-column gap-2">
                                                    {/* Top row: Title and Status */}
                                                    <div className="d-flex justify-content-between align-items-start">
                                                        <h6 className="fw-semibold text-dark mb-0 pe-3" style={{ letterSpacing: "-0.3px" }}>{subTask?.title}</h6>
                                                        <div className="flex-shrink-0 d-flex flex-column align-items-end gap-2">
                                                            {handleTaskStatus(subTask?.status)}
                                                        </div>
                                                    </div>

                                                    {/* Middle row: Priority, Due Date, Created by */}
                                                    <div className="d-flex flex-wrap justify-content-between align-items-center mt-2">
                                                        <div className="d-flex align-items-center gap-2">
                                                            {handlePriorityStatus(subTask?.priority)}
                                                            <div className={`d-flex align-items-center fw-bold ${subTask.overdue || moment(subTask.dueDate).isBefore(moment().format("YYYY-MM-DD")) ? 'text-danger' : 'text-muted'}`} style={{ fontSize: "11px" }}>
                                                                {(subTask.overdue || moment(subTask.dueDate).isBefore(moment().format("YYYY-MM-DD"))) ? (
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="me-1" viewBox="0 0 16 16">
                                                                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                                                                    </svg>
                                                                ) : null}
                                                                {moment(subTask?.dueDate).format("DD MMM YYYY")}
                                                                {(subTask.overdue || moment(subTask.dueDate).isBefore(moment().format("YYYY-MM-DD"))) && <span className="ms-1">· Overdue</span>}
                                                            </div>
                                                        </div>
                                                        <div className="d-flex align-items-center gap-1">
                                                            <span className="text-muted" style={{ fontSize: "10px" }}>Created by</span>
                                                            <span className="fw-bold text-primary" style={{ fontSize: "11px" }}>{taskDetail?.assignedUsers?.find((user) => user?.id === subTask?.createdById)?.name}</span>
                                                        </div>
                                                    </div>

                                                    {/* Bottom row: Description & Actions */}
                                                    <div className="d-flex justify-content-between align-items-end mt-1">
                                                        <div className="flex-grow-1 pe-4">
                                                            <p className="mb-0 text-secondary" style={{ fontSize: '12px', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                                                {subTask?.description || "No description provided."}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}

                            </div>}

                        <div className="pt-2">
                            <div className="text-muted text-uppercase mb-2 fw-bold" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>Comments</div>
                            {taskDetail?.taskcomments?.length === 0 ? (
                                <p className="mb-2 text-muted" style={{ fontStyle: 'italic', fontSize: '11px' }}>No comments yet.</p>
                            ) : (
                                <div className="mb-2 d-flex flex-column gap-2 overflow-auto border rounded-3 p-2" style={{ maxHeight: '300px' }}>
                                    {taskDetail?.taskcomments?.map((comment) => (
                                        <div key={comment?.id} className="d-flex align-items-start gap-2 mb-2 flex-shrink-0">
                                            <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: "24px", height: "24px", fontSize: "10px", fontWeight: "600" }}>
                                                {getInitials(comment?.user?.name)}
                                            </div>
                                            <div className="bg-light p-2 rounded-4 flex-grow-1 border-0 shadow-sm">
                                                <div className="d-flex justify-content-between align-items-center mb-1">
                                                    <span className="fw-bold text-dark" style={{ fontSize: "11px" }}>{comment?.user?.name}</span>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <small className="text-muted" style={{ fontSize: "9px" }}>{moment(comment?.createdAt).format("DD MMM YYYY, HH:mm")}</small>
                                                        {comment?.userId === userDetails?.id && (
                                                            <button onClick={() => handleCommentDelete(comment?.id)} disabled={isLoadingCommentDelete} className="btn btn-link text-danger p-0 m-0 d-flex align-items-center" title="Delete Comment">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" /><path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" /></svg>
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                                <p className="mb-0 text-secondary" style={{ fontSize: "11px" }}>{comment?.comment}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                            <div className="d-flex align-items-center gap-2 mt-2">
                                <input
                                    type="text"
                                    className="form-control rounded-3"
                                    placeholder="Add a comment..."
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && comment?.trim() && !isLoadingComment) {
                                            e.preventDefault();
                                            handleAddComment();
                                        }
                                    }}
                                    disabled={isLoadingComment}
                                    style={{ fontSize: '12px', padding: '6px 12px' }}
                                />
                                <button
                                    className="btn btn-dark rounded-3 px-3 fw-bold btn-sm"
                                    onClick={handleAddComment}
                                    disabled={!comment?.trim() || isLoadingComment}
                                    style={{ padding: '6px 12px', whiteSpace: 'nowrap' }}
                                >
                                    {isLoadingComment ? <Spinner size="sm" /> : "Send"}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </ModalBody>
        </Modal>
    );
};

export default TaskDetailModal;
